import { Button, Icon, Link, useColorMode } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools';
import React, { ReactElement } from 'react';
import { Accessible } from '@mui/icons-material';

import { fixedCustomStyles } from '../../theme/foundations/fixedTextSizes';
import { NavItem } from '..';
import { OptionsPopover } from '../popover/OptionsPopover';

export const NavDesktopLinks = (): ReactElement => {
  const modeProps = useColorMode();

  return (
    <NavItem variant="default">
      <OptionsPopover>
        <Link
          as={Button}
          alignItems="center"
          fontWeight="bold"
          _hover={{
            textDecoration: 'none',
            backgroundColor: mode(
              'brand.hover.blue',
              'brand.hover.yellow',
            )(modeProps),
          }}
        >
          <Icon
            mr={2}
            textStyle="h3"
            fontSize={fixedCustomStyles.textStyles.h3.fontSize}
            lineHeight={fixedCustomStyles.textStyles.h3.lineHeight}
            as={Accessible}
            color={mode('brand.black', 'brand.yellow')(modeProps)}
          />
          Accessibility Options
        </Link>
      </OptionsPopover>
    </NavItem>
  );
};
